import { requests } from "../config";
import { TRANSPORT_AREAS } from "../settings";
import { IChangeKavData, IPutAreaLoad, IPutPalletStatus, IShowDriverKav, IUpdateCarDriver } from "./models/fetchData";
import { IKavTitleItem } from "./models/kavTitle";
import { IGetPalletListByKavParams, IPalletByKavItem } from "./models/palletByKav";


export const Trucks = {
    getOrdersTree: (date: string) => requests.get(`distribution/orders_tree?date=${date}`, 'go'),
    changeKav: (data: IChangeKavData) => requests.put('distribution/change_line', 'go', data),
    patchDriver: (kavID: number, data: {CarId: number}) => requests.put(`${TRANSPORT_AREAS}${kavID}`, 'node', data),
    updateCarDriver: (kavID: number, data: IUpdateCarDriver) => requests.put(`transport_area/by_date/${kavID}`, 'go', data),
    showDriverKav: (kavID: number, data: IShowDriverKav) => requests.put(`transport_area/open/${kavID}`, 'go', data),
    sortKavByOrders: (data: number[], kavID: number) => requests.put(`distribution/distr_order/${kavID}`, 'go', data),
    bulkConfirm: (data: IUpdateCarDriver[]) => requests.put(`transport_area/update_by_date/bulk`, 'go', data),
    setSort: (data: number[]) => requests.put(`transport_area/sort/bulk`, 'go', data),
    setLikutSort: (date: string, data: number[]) => requests.put(`transport_area/pickup/order?Date=${date}`, 'go', data),
    getKavTitleList: (date: string): Promise<IKavTitleItem[]> => requests.get(`transport_area/areas?Date=${date}`, 'go'),
    getPalletListByKav: (data: string): Promise<IPalletByKavItem[]> => requests.get(`transport_area/${data}`, 'go'),
    putPalletStatus: (data: IPutPalletStatus) => requests.put(`/transport_area/pallet/status`, 'go', data),
    areaLoad: (data: IPutAreaLoad) => requests.put(`/transport_area/area/loaded`, 'go', data),
}